import React, { useCallback, useState } from 'react';
import shuffle from 'lodash/shuffle';
import {
  CSSGrid, layout, makeResponsive,
} from 'react-stonecutter';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import StyledWork from './Work.style';
import VideoSlider from './VIdeoSlider';
import StyledVideoSlider from './VideoSlider.style';
import FilterButton from './FilterButton';
import FilterButtonWrapper from './FilterButtonWrapper.style';
import VideoCard from './VideoCard';
import SectionTitle from '../../../SectionTitle.style';
import { useMobile } from '../../queries';
import VideoItemMobile from './VideoItemMobile';
import { COMMERCIAL, MUSIC_VIDEO } from './consts';

// const getThumbnail = (id = '458326260') => fetch(`https://vimeo.com/api/v2/video/${id}.json`).then((d) => d.json()).then((data) => {
//   const thumbSRClarge = data[0].thumbnail_large;
//   const thumbSplit = thumbSRClarge.split(/\d{3}(?=.jpg)/);
//   const thumbSRC = `${thumbSplit[0]}1280x720${thumbSplit[1]}`;
//   console.log(thumbSRC);
// });

// get thumbnail : https://depone.dev/video/
const videos = [
  {
    title: 'BIONIC - Space Disco (Official Music Video)', type: MUSIC_VIDEO, id: '581929797', thumbnail: '1204391261',
  },
  {
    title: 'Nadav Philips - Jet Lag (Music Video)', type: MUSIC_VIDEO, id: '437410683', thumbnail: '922820395',
  },
  {
    title: 'UPS latino x SPOT', type: COMMERCIAL, id: '582589674', thumbnail: '1205765344',
  },
  {
    title: 'UPS latino businesses support spot', type: COMMERCIAL, id: '582590056', thumbnail: '1205764833',
  },
  {
    title: 'J Balvin & UPS Latino x', type: COMMERCIAL, id: '582587547', thumbnail: '1205759352',
  },
  {
    title: 'Gucci x Louis Vuitton x Chanel Fashion SPOT', type: COMMERCIAL, id: '581249917', thumbnail: '1202673861',
  },
  {
    title: 'ARTPiece by ShapiraBros', type: COMMERCIAL, id: '581246025', thumbnail: '1202669470',
  },
  {
    title: 'SoHo Brand IG Commercial', type: COMMERCIAL, id: '519588595', thumbnail: '1076016639',
  },
  {
    title: 'Emilia Pedersen - SKYLINE (Warner Music)', type: MUSIC_VIDEO, id: '439768902', thumbnail: '984528888',
  },
  {
    title: 'ARTGRID Commercial (2020)', type: COMMERCIAL, id: '473455447', thumbnail: '984529727',
  },
  {
    title: 'DJ Aron & Beth Sacks - ONE LIFE (Apple Music)', type: MUSIC_VIDEO, id: '458326260', thumbnail: '984528537',
  },
  {
    title: 'Nadav Philips - Layla Meshuga', type: MUSIC_VIDEO, id: '382113933', thumbnail: '843120587',
  },
  {
    title: 'Keren Peles & Ron Buhnik - Mehevr La\'Nahar', type: MUSIC_VIDEO, id: '382113590', thumbnail: '843120074',
  },
  {
    title: 'Dynamic HD Video Calls - Temi The Personal Robot', type: COMMERCIAL, id: '382113186', thumbnail: '843119323',
  },
  {
    title: 'Amazon - Car seat storage organizer', type: COMMERCIAL, id: '382113112', thumbnail: '843119298',
  },
  {
    title: 'Empire Cruises', type: COMMERCIAL, id: '382113308', thumbnail: '843119721',
  },
  {
    title: 'Facetune Commercial', type: COMMERCIAL, id: '382113410', thumbnail: '843119742',
  },
  {
    title: 'Flawless Autonomous Movement - Temi The Personal Robot', type: COMMERCIAL, id: '382113426', thumbnail: '843119767',
  },
  {
    title: 'Glass Shattering Speakers - temi The Personal Robot', type: COMMERCIAL, id: '382113436', thumbnail: '843119780',
  },
  {
    title: 'It\'s a Selfie Machine - temi The Personal Robot', type: COMMERCIAL, id: '382113445', thumbnail: '843119795',
  },
  {
    title: 'KALTURA SPOT', type: COMMERCIAL, id: '382113455', thumbnail: '843119856',
  },
  {
    title: 'KALTURA COMMERCIAL', type: COMMERCIAL, id: '382113487', thumbnail: '843119896',
  },
  {
    title: 'Amazon - Karoki ', type: COMMERCIAL, id: '382113503', thumbnail: '843120021',
  },
  {
    title: 'Amazon - Kids travel tray', type: COMMERCIAL, id: '382113625', thumbnail: '843120219',
  },
  {
    title: 'Medisana - Temi Robot', type: COMMERCIAL, id: '382113713', thumbnail: '843120267',
  },
  {
    title: 'Eliya Sinai - Girls Like You', type: MUSIC_VIDEO, id: '382113196', thumbnail: '843119545',
  },
  {
    title: 'Nadav Philips - Nishar Siman', type: MUSIC_VIDEO, id: '382113997', thumbnail: '843120657',
  },
  {
    title: 'OPPO', type: COMMERCIAL, id: '382114066', thumbnail: '843120734',
  },
  {
    title: 'Amazon - Playground', type: COMMERCIAL, id: '382114109', thumbnail: '843120817',
  },
  {
    title: 'Amazon - Teddy Bear', type: COMMERCIAL, id: '382114173', thumbnail: '843120969',
  },
  {
    title: 'Temi with Alexa for retail', type: COMMERCIAL, id: '382114249', thumbnail: '843121036',
  },
  {
    title: 'YOTPO', type: COMMERCIAL, id: '382114287', thumbnail: '843121245',
  },
  {
    title: 'Federica Carta - Bullshit', type: MUSIC_VIDEO, id: '423621405', thumbnail: '900156217',
  },
  {
    title: 'AVRAHAM - I won’t let you go', type: MUSIC_VIDEO, id: '423612465', thumbnail: '900145100',
  },
  {
    title: 'The Ultra - Look Like Kylie', type: MUSIC_VIDEO, id: '385851368', thumbnail: '848150161',
  },
  {
    title: 'Aviv Terner - Azman Azal', type: MUSIC_VIDEO, id: '402950674', thumbnail: '872232345',
  },
  {
    title: 'PESAN CINTA', type: MUSIC_VIDEO, id: '402951400', thumbnail: '872234334',
  },
  {
    title: 'ELLE Magazine Fashion', type: COMMERCIAL, id: '428192363', thumbnail: '907492754',
  },
  {
    title: 'TOP10.ME Spot (Dating APP)', type: COMMERCIAL, id: '430744795', thumbnail: '911516581',
  },
  {
    title: 'OPPO Commercial (Camera)', type: COMMERCIAL, id: '430744849', thumbnail: '911517329',
  },
];

const Grid = makeResponsive(CSSGrid, {
  maxWidth: 1920,
  minPadding: 100,
});

export const enter = () => ({
  rotate: 45,
  scale: 0,
  opacity: 0,
});

export const exit = () => ({
  rotate: -45,
  scale: 0,
  opacity: 0,
});

export const entered = () => ({
  rotate: 0,
  scale: 1,
  opacity: 1,
});


const Work = React.forwardRef((props, ref) => {
  const [data, setData] = useState(videos);
  const [activeButton, setActiveButton] = useState('ALL');
  const [activeGridIndex, setActiveGridIndex] = useState(0);
  const videoSliderRef = React.useRef();
  const scrollToVideoSlider = useCallback(() => videoSliderRef.current.scrollIntoView({ behavior: 'smooth' }), []);
  const isMobile = useMobile();

  const handleFilter = (filterType) => () => {
    if (filterType === activeButton) {
      return;
    }
    let filteredVideos = [...videos];
    if (filterType !== 'ALL') {
      filteredVideos = videos.filter((video) => video.type === filterType);
    }
    const shuffledVideos = shuffle(filteredVideos);
    setActiveGridIndex(0);
    setData(shuffledVideos);
    setActiveButton(filterType);
  };

  const setGridIndexAndScroll = (index) => () => {
    setActiveGridIndex(index);
    scrollToVideoSlider();
  };

  const items = data.map((video, idx) => (
    <li key={video.id} itemHeight={250}>
      <VideoCard
        title={video.title}
        thumbnail={video.id}
        index={idx}
        type={video.type}
        isActive={activeGridIndex === idx}
        onClick={setGridIndexAndScroll(idx)}
      />
    </li>
  ));

  return (
    <StyledWork id="work">
      <SectionTitle style={{ padding: '30px 0 15px' }}> Our Videos </SectionTitle>
      {isMobile
        ? <VideoItemMobile ref={videoSliderRef} video={data[activeGridIndex]} />
        : (
          <StyledVideoSlider>
            <VideoSlider
              data={data}
              activeGridIndex={activeGridIndex}
              setActiveGridIndex={setActiveGridIndex}
              ref={videoSliderRef}
            />
          </StyledVideoSlider>
        )}

      <FilterButtonWrapper ref={ref}>
        <FilterButton onClick={handleFilter('ALL')} active={activeButton === 'ALL'}>
          All Videos
        </FilterButton>
      </FilterButtonWrapper>
      <FilterButtonWrapper>
        <FilterButton onClick={handleFilter(MUSIC_VIDEO)} active={activeButton === MUSIC_VIDEO}>
          Music Videos
        </FilterButton>
        <FilterButton onClick={handleFilter(COMMERCIAL)} active={activeButton === COMMERCIAL}>
            Commercials
        </FilterButton>
      </FilterButtonWrapper>


      <Grid
        component="ul"
        columns={4}
        columnWidth={isMobile ? 275 : 350}
        gutterWidth={20}
        gutterHeight={isMobile ? 5 : 30}
        layout={layout.pinterest}
        duration={1000}
        easing="cubic-bezier(0.645, 0.045, 0.355, 1)"
        enter={enter}
        entered={entered}
        exit={exit}
      >
        {items}
      </Grid>
    </StyledWork>
  );
});

export default Work;
